<template>
  <v-dialog v-model="dialog" max-width="600px" persistent scrollable>
    <v-card style="border-radius: 10px">
      <v-toolbar
        dark
        style="background-color: #fddf00; color: black"
        class="elevation-0"
      >
        <v-toolbar-title>
          <h4>{{ isEdit ? "Edit Hotel" : "Create Hotel" }}</h4>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="closeDialog" color="black" size="30">close</v-icon>
      </v-toolbar>
      <v-card-text style="height: auto" class="px-4 pt-4">
        <v-layout row wrap>
          <v-flex xs12>
            <v-form ref="formInfo" v-model="valid" lazy-validation>
              <div class="section-border">
                <h4>Hotel Information</h4>
                <v-text-field
                  v-model="hotel.name"
                  label="Hotel Name"
                  :rules="[(v) => !!v || 'Hotel Name is required']"
                  required
                ></v-text-field>
                <v-textarea
                  v-model="hotel.description"
                  label="Description"
                  :rules="[(v) => !!v || 'Description is required']"
                  required
                ></v-textarea>
                <v-text-field
                  v-model="hotel.star_rating"
                  label="Star Rating"
                  :rules="[(v) => !!v || 'Star Rating is required']"
                  required
                ></v-text-field>
                <v-text-field
                  v-model="hotel.contact_email"
                  label="Contact Email"
                  :rules="[
                    (v) => !!v || 'Contact Email is required',
                    (v) => /.+@.+\..+/.test(v) || 'Email must be valid',
                  ]"
                  required
                ></v-text-field>
                <v-text-field
                  v-model="hotel.contact_phone"
                  label="Contact Phone"
                  :rules="[(v) => !!v || 'Contact Phone is required']"
                  required
                ></v-text-field>
                <v-text-field
                  v-model="hotel.website"
                  label="Website"
                  :rules="[(v) => !!v || 'Website is required']"
                  required
                ></v-text-field>
                <v-btn
                  color="success"
                  style="
                    width: 120px;
                    background: #000000 0% 0% no-repeat padding-box;
                    box-shadow: 0px 3px 6px #00000029;
                    border-radius: 7px;
                    font-weight: bold;
                    letter-spacing: 0.1rem;
                    color: white;
                    margin-top: 20px;
                  "
                  @click="saveHotelSection('hotelInfo')"
                  :loading="saving"
                >
                  Save
                </v-btn>
              </div>
            </v-form>
          </v-flex>
          <v-flex xs12>
            <v-form ref="formAppStyle" v-model="valid" lazy-validation>
              <div class="section-border">
                <h4>App Style</h4>
                <v-text-field
                  v-model="hotel.app_style.primary_color"
                  label="Primary Color"
                  :rules="[(v) => !!v || 'Primary Color is required']"
                  required
                ></v-text-field>
                <v-text-field
                  v-model="hotel.app_style.secondary_color"
                  label="Secondary Color"
                  :rules="[(v) => !!v || 'Secondary Color is required']"
                  required
                ></v-text-field>
                <v-text-field
                  v-model="hotel.app_style.hotel_logo"
                  label="Hotel Logo URL"
                  :rules="[(v) => !!v || 'Hotel Logo URL is required']"
                  required
                ></v-text-field>
                <v-text-field
                  v-model="hotel.app_style.hotel_service_domain"
                  label="Hotel Service Domain"
                  :rules="[(v) => !!v || 'Hotel Service Domain is required']"
                  required
                ></v-text-field>
                <v-btn
                  color="success"
                  style="
                    width: 120px;
                    background: #000000 0% 0% no-repeat padding-box;
                    box-shadow: 0px 3px 6px #00000029;
                    border-radius: 7px;
                    font-weight: bold;
                    letter-spacing: 0.1rem;
                    color: white;
                    margin-top: 20px;
                  "
                  @click="saveHotelSection('appStyle')"
                  :loading="saving"
                >
                  Save
                </v-btn>
              </div>
            </v-form>
          </v-flex>
          <v-flex xs12>
            <v-form ref="formLocation" v-model="valid" lazy-validation>
              <div class="section-border">
                <h4>Location</h4>
                <v-text-field
                  v-model="hotel.locations[0].name"
                  label="Location"
                  :rules="[(v) => !!v || 'Location is required']"
                  required
                ></v-text-field>
                <v-text-field
                  v-model="hotel.locations[0].latitude"
                  label="Latitude"
                  :rules="[(v) => !!v || 'Latitude is required']"
                  required
                ></v-text-field>
                <v-text-field
                  v-model="hotel.locations[0].longitude"
                  label="Longitude"
                  :rules="[(v) => !!v || 'Longitude is required']"
                  required
                ></v-text-field>
                <v-text-field
                  v-model="hotel.locations[0].province"
                  label="Province"
                  :rules="[(v) => !!v || 'Province is required']"
                  required
                ></v-text-field>
                <v-btn
                  color="success"
                  style="
                    width: 120px;
                    background: #000000 0% 0% no-repeat padding-box;
                    box-shadow: 0px 3px 6px #00000029;
                    border-radius: 7px;
                    font-weight: bold;
                    letter-spacing: 0.1rem;
                    color: white;
                    margin-top: 20px;
                  "
                  @click="saveHotelSection('location')"
                  :loading="saving"
                >
                  Save
                </v-btn>
              </div>
            </v-form>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    hotelData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      valid: true,
      hotel: {
        name: "",
        description: "",
        star_rating: null,
        contact_email: "",
        contact_phone: "",
        website: "",
        locations: [
          {
            name: "",
            latitude: "",
            longitude: "",
            province: "",
          },
        ],
        app_style: {
          primary_color: "",
          secondary_color: "",
          hotel_logo: "",
          hotel_service_domain: "",
        },
      },
      saving: false,
    };
  },
  computed: {
    isEdit() {
      return !!this.hotelData.name;
    },
  },
  watch: {
    dialog() {
      if (this.dialog == true) {
        this.hotel = {
          hotel_id: this.hotelData.hotel_id || null,
          name: this.hotelData.name || "",
          description: this.hotelData.description || "",
          star_rating: this.hotelData.star_rating || null,
          contact_email: this.hotelData.contact_email || "",
          contact_phone: this.hotelData.contact_phone || "",
          website: this.hotelData.website || "",
          locations: [
            {
              location_id: this.hotelData.locations[0].location_id || null,
              name: this.hotelData.locations[0].name || "",
              latitude: this.hotelData.locations[0].latitude || "",
              longitude: this.hotelData.locations[0].longitude || "",
              province: this.hotelData.locations[0].province || "",
            },
          ],
          app_style: {
            primary_color: this.hotelData.app_style.primary_color || "",
            secondary_color: this.hotelData.app_style.secondary_color || "",
            hotel_logo: this.hotelData.app_style.hotel_logo || "",
            hotel_service_domain:
              this.hotelData.app_style.hotel_service_domain || "",
          },
        };
        if (!this.isEdit) {
          if (this.$refs.form) {
            this.$refs.form.resetValidation();
          }
        }
      }
    },
  },
  methods: {
    closeDialog() {
      this.$emit("close", false);
      this.resetForm();
    },
    saveHotelSection(section) {
      let hotelClone = JSON.parse(JSON.stringify(this.hotel));
      let _this = this;
      if (section === "hotelInfo") {
        if (this.$refs.formInfo.validate()) {
          this.saving = true;
          this.$emit("updateInfo", {
            data: hotelClone,
            section,
            done() {
              _this.saving = false;
              _this.snackBarMsg = "Hotel information saved successfully!";
            },
            failed() {
              _this.saving = false;
            },
          });
        }
      } else if (section === "appStyle") {
        if (this.$refs.formAppStyle.validate()) {
          this.saving = true;
          this.$emit("updateAppStyle", {
            data: hotelClone,
            section,
            done() {
              _this.saving = false;
              _this.snackBarMsg = "App style saved successfully!";
            },
            failed() {
              _this.saving = false;
            },
          });
        }
      } else if (section === "location") {
        if (this.$refs.formLocation.validate()) {
          this.saving = true;
          this.$emit("updateLocation", {
            data: hotelClone,
            section,
            done() {
              _this.saving = false;
              _this.snackBarMsg = "Location saved successfully!";
            },
            failed() {
              _this.saving = false;
            },
          });
        }
      }
    },
    resetForm() {
      this.hotel = {
        name: "",
        description: "",
        star_rating: null,
        contact_email: "",
        contact_phone: "",
        website: "",
        locations: [
          {
            name: "",
            latitude: "",
            longitude: "",
            province: "",
          },
        ],
        app_style: {
          primary_color: "",
          secondary_color: "",
          hotel_logo: "",
          hotel_service_domain: "",
        },
      };
    },
  },
};
</script>

<style>
.section-border {
  border: 1px solid #ddd;
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 10px;
}
.line-newpass {
  overflow: visible;
  padding: 0;
  border: none;
  border-top: 2px solid black;
  color: #333;
  text-align: center;
  margin-top: 25px;
}

.line-newpass:after {
  content: "Set Password";
  display: inline-block;
  position: relative;
  top: -0.8em;
  font-size: 17px;
  padding: 0 0.25em;
  background: white;
}
</style>
